<template>
  <div id="app">
    <SideBarNavigation />
    <div class="container">
      <Spotlight />
      <router-view :key="$route.path" />
    </div>
  </div>
</template>

<script>
import SideBarNavigation from "@/components/shared/SideBarNavigation"
import Spotlight from "@/components/Search/Spotlight"

export default {
  name: "App",
  components: { SideBarNavigation, Spotlight },
  data() {
    return {
      quote: undefined,
    }
  },
  mounted() {
    window.Prism.highlightAll()
    this.$nextTick(() => {
      window.Prism.highlightAll()
    })
  },
}
</script>

<style>
.link {
  color: lightblue;
  cursor: pointer;
}
.link:hover {
  color: darkblue;
}
input {
  width: 90%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.calender-div {
  position: relative;
  z-index: 100;
  border: 1px solid black;
}
/* TABLE */
tr {
  border-bottom: 1px solid white;
}
table {
  overflow: hidden;
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  padding: 15px;
}
th {
  text-align: left;
}

tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
tbody td {
  position: relative;
}

/* TABLE */
.loading-upload-container {
  position: fixed;
  z-index: 100;
  top: 0px;
  left: 1px;
  width: 100%;
  height: 100%;
  padding: 10px;
  color: green;
  background-color: white;
  background-image: url("http://99knig.download/wp-content/uploads/2018/04/wave.gif");
  background-repeat: no-repeat;
  background-position: center center;
}

.input-box-course-creators {
  width: 96%;
  margin: auto;
  margin-bottom: 8px;
}
.quote {
  color: grey;
  font-size: 0.7em;
}
.container {
  width: 100%;
  max-width: 85%;
  margin: auto;
  margin-top: 1rem;
}

.level-custom {
  padding: 13px;
  background: #f6f6f6;
}

.course-content-editor-container {
  z-index: 100;
  width: 520px;
  padding: 20px;
  border: 1px solid #d6d6d6;
  background-color: #f5f5f5;
}

/*Theme*/
/**
* xonokai theme for JavaScript, CSS and HTML
* based on: https://github.com/MoOx/sass-prism-theme-base by Maxime Thirouin ~ MoOx --> http://moox.fr/ , which is Loosely based on Monokai textmate theme by http://www.monokai.nl/
* license: MIT; http://moox.mit-license.org/
*/
code[class*="language-"],
pre[class*="language-"] {
  color: #76d9e6;
  text-shadow: none;
  font-family: Menlo, Monaco, "Courier New", monospace;
  font-size: 14px;
  white-space: pre;
  white-space: pre-wrap;
  word-wrap: normal;
  -moz-tab-size: 2;
  -o-tab-size: 2;
  tab-size: 2;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}
pre[class*="language-"],
:not(pre) > code[class*="language-"] {
  background: #2a2a2a;
}
pre[class*="language-"] {
  overflow: auto;
  padding: 15px;
  border: 1px solid #e1e1e8;
  border-radius: 4px;
}

pre[class*="language-"] {
  position: relative;
}
pre[class*="language-"] code {
  display: block;
  white-space: pre;
}

:not(pre) > code[class*="language-"] {
  padding: 0.15em 0.2em 0.05em;
  border: 0.13em solid #7a6652;
  border-radius: 0.3em;
  box-shadow: 1px 1px 0.3em -0.1em #000 inset;
}
.token.namespace {
  opacity: 0.7;
}
.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #6f705e;
}
.token.operator,
.token.boolean,
.token.number {
  color: #a77afe;
}
.token.attr-name,
.token.string {
  color: #e6d06c;
}
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #e6d06c;
}
.token.selector,
.token.inserted {
  color: #a6e22d;
}
.token.atrule,
.token.attr-value,
.token.keyword,
.token.important,
.token.deleted {
  color: #ef3b7d;
}
.token.regex,
.token.statement {
  color: #76d9e6;
}
.token.placeholder,
.token.variable {
  color: #fff;
}
.token.important,
.token.statement,
.token.bold {
  font-weight: bold;
}
.token.punctuation {
  color: #bebec5;
}
.token.entity {
  cursor: help;
}
.token.italic {
  font-style: italic;
}

code.language-markup {
  color: #f9f9f9;
}
code.language-markup .token.tag {
  color: #ef3b7d;
}
code.language-markup .token.attr-name {
  color: #a6e22d;
}
code.language-markup .token.attr-value {
  color: #e6d06c;
}
code.language-markup .token.style,
code.language-markup .token.script {
  color: #76d9e6;
}
code.language-markup .token.script .token.keyword {
  color: #76d9e6;
}

/* Line highlight plugin */
pre[class*="language-"][data-line] {
  position: relative;
  padding: 1em 0 1em 3em;
}
pre[data-line] .line-highlight {
  position: absolute;
  right: 0;
  left: 0;
  margin-top: 1em;
  padding: 0;
  background: rgba(255, 255, 255, 0.08);
  line-height: inherit;
  white-space: pre;
  pointer-events: none;
}
pre[data-line] .line-highlight:before,
pre[data-line] .line-highlight[data-end]:after {
  position: absolute;
  top: 0.4em;
  left: 0.6em;
  min-width: 1em;
  height: 1em;
  padding: 0.2em 0.5em;
  border-radius: 999px;
  color: black;
  background-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);
  text-shadow: none;
  font: bold 65%/1 sans-serif;
  line-height: 1em;
  text-align: center;
  content: attr(data-start);
}
pre[data-line] .line-highlight[data-end]:after {
  top: auto;
  bottom: 0.4em;
  content: attr(data-end);
}

/* Form Base Styles | general input, textarea, select */
.edyst-form-group {
  color: #5c5c5c;
}

.edyst-form-group label {
  font-size: 16px;
}

.edyst-form-group input[type="text"],
.edyst-form-group input[type="email"],
.edyst-form-group input[type="number"],
.edyst-form-group input[type="url"],
.edyst-form-group select,
.edyst-form-group textarea {
  width: 100%;
  height: 35px;
  margin-top: 10px;
  padding: 3px 8px;
  border-width: 0;
  border-radius: 3px;
  background-color: #f2f7fa;
  box-shadow: none;
  font-size: 16px;
  transition: ease-out;
  transition-duration: 0.2s;
  transition-property: border-color, outline, box-shadow;
}

.edyst-form-group input[type="text"]:focus,
.edyst-form-group input[type="email"]:focus,
.edyst-form-group input[type="number"]:focus,
.edyst-form-group input[type="url"]:focus,
.edyst-form-group select:focus,
.edyst-form-group textarea:focus {
  border-color: #8598ff;
  outline: none;
  box-shadow: 0 0 5px 2px #8598ff;
}

/* Custom form css overrides for radio buttons */
.edyst-form-group .form-group.field-radios label span {
  margin-bottom: 10px;
}

.edyst-form-group .form-group.field-radios .radio-list label {
  margin-bottom: 5px;
}

.edyst-form-group input::placeholder,
.edyst-form-group select::placeholder,
.edyst-form-group textarea::placeholder {
  color: #5c5c5c;
  font-size: 0.875rem;
}

.edyst-form-group .is-invalid {
  border: 1px solid #ff504a !important;
  background: #fffafa !important;
}

.fadeIn {
  animation: fadeIn 0.3s ease-out;
}

.slideUp {
  animation: slide-up 0.3s ease-out;
}

.fadeOut {
  animation: fadeIn 0.3s ease-out reverse;
}

button:disabled {
  cursor: not-allowed;
}

/* default quill editor font size */
.ql-container {
  font-size: 1rem;
}

.noty_body {
  color: white;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(1.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes zoom {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* change default animation of swal */
.swal-overlay--show-modal .swal-modal {
  animation: zoom 0.1s ease-in-out;
}
</style>
